import { ContainerBase, SimpleBanner } from '@/components/landing';
import Images from '@/const/images';
import clsx from 'clsx';
import Image from 'next/image';
import * as React from 'react';

interface ContainerEmailPreviewI {
	children: React.ReactNode;
	type?: 'landing' | 'email';
}

export const ContainerEmailPreview: React.FC<ContainerEmailPreviewI> = ({
	children,
	type = 'landing',
}) => {
	const logoUrl = Images.logo;
	return (
		<div>
			{type === 'landing' && (
				<SimpleBanner
					customTitle={
						<Image
							width={345}
							height={64}
							alt="logo"
							src={logoUrl}
							className="mx-auto"
							quality={75}
						/>
					}
				/>
			)}
			<ContainerBase
				className={clsx('pb-14 relative', {
					'bg-[#F4F4F9] !px-0 lg:!px-0': type === 'email',
				})}
			>
				{type === 'landing' ? (
					<LayoutLandingPreview>{children}</LayoutLandingPreview>
				) : (
					<LayoutEmailPreview>{children}</LayoutEmailPreview>
				)}
			</ContainerBase>
		</div>
	);
};

interface Props {
	children: React.ReactNode;
}

export const LayoutLandingPreview: React.FC<Props> = ({ children }) => {
	return (
		<>
			<span
				className={clsx(
					"bg-[url('/img/landing/line-green-left.png')] left-0 absolute bg-contain bg-no-repeat bg-center w-[80%] xl:w-[30%] 2xl:w-[25.8%] 4xl:w-[30%]",
					'hidden xl:block lg:h-[170px] top-[300px] z-0'
				)}
			/>
			<div className="mt-14 pb-16 z-50 relative">{children}</div>
			<span
				className={clsx(
					"bg-[url('/img/landing/line-green-right.png')] absolute bg-contain bg-no-repeat bg-left-top w-[80%] xl:w-[25.8%] 4xl:w-[30%]",
					'hidden xl:block h-[190px] top-[300px]  right-0'
				)}
			/>

			<div className="absolute right-0 bottom-0">
				<div className="relative h-96 w-[300px]">
					<div className="absolute inset-0 bg-[url('/img/landing/svg/ellipse-right.svg')] bg-cover bg-no-repeat rotate-[0]" />
					<div className="absolute inset-0 bg-gradient-to-br from-[rgba(185,139,247,0)] to-[rgba(128,57,223,0)]" />
				</div>
			</div>
		</>
	);
};

export const LayoutEmailPreview: React.FC<Props> = ({ children }) => {
	return <>{children}</>;
};
